<template>
  <div class="chart-box" ref="chartBox" :style="getChartStyle">
    <v-chart
      v-if="showChart && !isEmptyData"
      class="chart"
      :init-options="getInitOptions"
      :option="getNewOption"
      ref="pie3D"
      theme="ovilia-green"
      autoresize
    />
    <!-- 空数据 -->
    <div class="null-data" v-if="isEmptyData">
      <img src="../../../../assets/images/img-null-data-light.png" alt="" />
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script>
import parentMixin from "components/bigScreenComponents/base"
import plugins from "./plugin"
import { hasProperty } from "utils"
import handleChartData from "utils/updateData/chart/handleChartData.js"

export default {
  mixins: [parentMixin, plugins, handleChartData],
  name: "cxPie3D",
  data() {
    return {
      autoPlayToolTipTimer: null,
      tooltipIndex: 0,
      eventCallbackList: {
        click: [],
        dblclick: [],
        mouseover: [],
        mouseout: [],
        mouseup: [],
        mousedown: [],
        touchstart: [],
        touchend: []
      }
    }
  },
  computed: {
    getNewOption() {
      let internalDiameterRatio = this.getOption.internalDiameterRatio
      let k =
        typeof internalDiameterRatio !== "undefined" ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio) : 1 / 3
      let minData = 1,
        minIndex = 0
      this.getOption.series.forEach((serie, index) => {
        // 计算
        if (serie.type !== "surface") {
          return
        }
        let startRatio = serie.pieData.startRatio
        let endRatio = serie.pieData.endRatio
        let isSelected = false
        let isHovered = false
        let height = serie.pieData.value
        // console.log("getParametricEquation")
        let midRatio = (startRatio + endRatio) / 2
        let startRadian = startRatio * Math.PI * 2
        let endRadian = endRatio * Math.PI * 2
        let midRadian = midRatio * Math.PI * 2
        if (minData > endRatio - startRatio) {
          minData = endRatio - startRatio
          minIndex = index
        }
        //如果只有一个扇形，则不实现选中效果。
        if (startRatio === 0 && endRatio === 1) {
          isSelected = false
        }

        // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
        k = typeof k !== "undefined" ? k : 1 / 3

        // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
        let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0
        let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0

        // 计算高亮效果的放大比例（未高亮，则比例为 1）
        let hoverRate = isHovered ? 1.05 : 1
        serie.parametricEquation = {
          u: {
            min: -Math.PI,
            max: Math.PI * 3,
            step: Math.PI / 32
          },
          v: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20
          },
          x: function (u, v) {
            if (u < startRadian) {
              return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            if (u > endRadian) {
              return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate
          },
          y: function (u, v) {
            if (u < startRadian) {
              return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            if (u > endRadian) {
              return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
            }
            return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate
          },
          z: function (u, v) {
            if (u < -Math.PI * 0.5) {
              return Math.sin(u)
            }
            if (u > Math.PI * 2.5) {
              return Math.sin(u)
            }
            return Math.sin(v) > 0 ? 1 * height : -1
          }
        }
      })
      /*var centerPoint =
        (Number(this.getOption.series[minIndex].pieData.endRatio) + Number(this.getOption.series[minIndex].pieData.startRatio)) / 2
      this.getOption.grid3D.viewControl.beta = -(360 - centerPoint * 360 - 90)*/
      return this.getOption
    }
  },
  watch: {
    "options.chartOption.series": function (newVal, oldVal) {
      if (newVal[0].animationDuration !== oldVal[0].animationDuration) {
        this.initOption = this.options.initOptions
      }
      if(this.options.numberCount){
        this.checkFormatterValue()
      }
    },
    getDragStatus(newVal, oldVal) {
      this.getDragStatusHandle(newVal, oldVal, "pie")
    },
    isAutoPlayToolTip(newVal, oldVal) {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 500)
    },
    autoPlayToolTipIntervalTime(newVal, oldVal) {
      if (this.isAutoPlayToolTip) {
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      }
    },
    showChart() {
      setTimeout(() => {
        this.autoplayTooltip()
      }, 500)
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.pie3D?.setOption(this.getOption)
        setTimeout(() => {
          this.autoplayTooltip()
        }, 500)
      } else {
        this.$refs.pie3D?.clear()
      }
    }
  },
  mounted() {
    this.refreshFunc()
    this.autoplayTooltip()
    this.checkFormatterValue()
  },
  destroyed() {
    clearInterval(this.autoPlayToolTipTimer)
    this.autoPlayToolTipTimer = null
  },
  methods: {
    /*inite3DPlugin(opt) {
      const plugins = [...this.options.chartOption.pluginName].filter(it => it.trim().length)
      plugins.forEach(pluginName => {
        if (hasProperty(this, pluginName) && typeof this[pluginName] === "function") {
          this[pluginName](opt)
        }
      })
    },*/
    autoplayTooltip() {
      clearInterval(this.autoPlayToolTipTimer)
      this.autoPlayToolTipTimer = null
      if (!this.options.isAutoPlayToolTip) {
        return
      }
      // 自动播放 tooltip 初始化
      let myChart = this.$refs.pie3D?.chart
      let data = this.getOption.series[this.getOption.series.length - 1].data
      this.autoPlayToolTipTimer = setInterval(() => {
        myChart._api.dispatchAction({
          type: "showTip",
          seriesIndex: this.getOption.series.length - 1,
          dataIndex: this.tooltipIndex
        })
        this.tooltipIndex++
        if (this.tooltipIndex > data.length - 1) {
          this.tooltipIndex = 0
        }
      }, this.options.autoPlayToolTipIntervalTime)
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
}
</style>
